module.exports = __webpack_public_path__ + "static/media/dipleo.84a11142.png";